import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RepositoryService } from './../../shared/services/repository.service';
import { RiskAudit } from '../../_interfaces/riskAudit.model';
import { RiskSummary } from '../../_interfaces/RiskSummary.model';
import { RiskService } from 'src/app/shared/services/risk.service';
import { map, switchMap } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';
import { RiskType } from 'src/app/_interfaces/RiskType.model';
import { HeadlineRisk } from 'src/app/_interfaces/HeadlineRisk.model';

@Component({
  selector: 'app-risk-audit-details',
  templateUrl: './risk-audit-details.component.html',
  styleUrls: ['./risk-audit-details.component.css']
})
export class RiskAuditDetailsComponent {

  constructor(public repository: RepositoryService,
    private riskService: RiskService,
    private router: Router,
    private activeRoute: ActivatedRoute) { }

  id$: Observable<number> = this.activeRoute.paramMap.pipe(
    map(params => +params.get('id')) 
  );

  riskAuditEntry$: Observable<RiskAudit> = this.id$.pipe(
    switchMap((id) => 
      forkJoin([
        this.getRiskAuditEntry(id),
        this.getRiskSummaryDetails(id)
      ])
    ),
    map(([riskAudit, riskSummary]) => {
      riskAudit.RiskSummary = riskSummary
      return riskAudit;
    })
  );

  riskType$: Observable<RiskType> = this.riskAuditEntry$.pipe(
    switchMap(riskAuditEntry => 
      this.riskService.getRiskTypeDetails(riskAuditEntry.riskType)
    )
  );

  headlineRisk$: Observable<HeadlineRisk> = this.riskAuditEntry$.pipe(
    switchMap(riskAuditEntry => 
      this.riskService.getHeadlineRiskDetails(riskAuditEntry)
    )
  );

  private getRiskAuditEntry(id: number): Observable<RiskAudit> {
    let apiUrl: string = `risksaudits/byriskauditid/${id}`;
    return this.repository.getData(apiUrl)
      .pipe(
        map(res => res as RiskAudit)
      )
  }


  private getRiskSummaryDetails(id: number): Observable<RiskSummary> {
    let apiUrl: string = `risksummary/byauditid/${id}`;

    return this.repository.getData(apiUrl)
      .pipe(
        map(res =>res as RiskSummary)
      )
  }
}
